/* global globalThis */
export function startCanvasRecording(canvas, { onComplete, onError }, Recorder = globalThis.MediaRecorder) {
  if (!canvas?.captureStream || !Recorder) throw new Error('Video recording is unavailable on this device.');
  const mimeType = ['video/mp4', 'video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'].find(type => Recorder.isTypeSupported(type));
  const stream = canvas.captureStream(30);
  let recorder, cancelled = false;
  const chunks = [];
  const release = () => stream.getTracks().forEach(track => track.stop());
  const videoBitsPerSecond = Math.min(50000000, Math.max(8000000,
    Math.round((canvas.width || 1920) * (canvas.height || 1080) * 30 * 0.3)));
  try { recorder = new Recorder(stream, { ...(mimeType ? { mimeType } : {}), videoBitsPerSecond }); }
  catch (error) { release(); throw error; }
  recorder.ondataavailable = event => { if (event.data.size) chunks.push(event.data); };
  recorder.onerror = event => { cancelled = true; release(); onError(event.error || new Error('Recording failed.')); };
  recorder.onstop = () => {
    release();
    if (cancelled) return;
    const blob = new Blob(chunks, { type: recorder.mimeType || mimeType || 'video/webm' });
    if (!blob.size) { onError(new Error('No video frames were recorded.')); return; }
    onComplete(blob);
  };
  try { recorder.start(1000); } catch (error) { release(); throw error; }
  return {
    stop() { if (recorder.state !== 'inactive') recorder.stop(); },
    cancel() { cancelled = true; if (recorder.state !== 'inactive') recorder.stop(); release(); },
  };
}
